var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolisticdigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.42,
    y1: 22.19,
    x2: 23.58,
    y2: 22.19,
    gradientTransform: "translate(0 26) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0067bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000c55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 10.61,
    x2: 23.58,
    y2: 10.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 16.75,
    y1: 12.01,
    x2: 18.11,
    y2: 12.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 19.46,
    y1: 12.01,
    x2: 20.82,
    y2: 12.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 5.89,
    y1: 12.01,
    x2: 7.25,
    y2: 12.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3.18,
    y1: 12.01,
    x2: 4.54,
    y2: 12.01,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.38,5.8c2.35-.1,4.5-.34,6.09-.69,.87-.19,1.56-.41,2.05-.66,.71-.35,1.06-.8,1.06-1.32,0-.86-.95-1.28-1.27-1.41-.6-.26-1.44-.5-2.49-.69-2.1-.39-4.88-.61-7.82-.61s-5.72,.22-7.82,.61c-1.05,.2-1.89,.43-2.49,.69-.31,.14-1.27,.56-1.27,1.41,0,.52,.36,.97,1.06,1.32,.49,.24,1.18,.47,2.05,.66,1.59,.35,3.74,.59,6.09,.69,.46,.84,1.35,1.41,2.38,1.41s1.91-.57,2.38-1.41h0ZM1.9,3.13c.29-.18,1.06-.54,3-.86,1.96-.32,4.48-.5,7.1-.5s5.14,.18,7.1,.5c1.94,.32,2.72,.67,3,.86-.25,.16-.88,.45-2.36,.74-1.36,.27-3.12,.46-5.02,.55-.03-1.47-1.24-2.65-2.71-2.65s-2.68,1.18-2.71,2.65c-1.9-.09-3.66-.29-5.02-.55-1.48-.29-2.11-.58-2.36-.74h0Zm10.1,2.71c-.75,0-1.36-.61-1.36-1.36s.61-1.36,1.36-1.36,1.36,.61,1.36,1.36-.61,1.36-1.36,1.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.72,18.93c-1.39-.34-3.27-.59-5.33-.72v-6.93h2.04c1.12,0,2.04-.91,2.04-2.04s-.91-2.04-2.04-2.04H6.57c-1.12,0-2.04,.91-2.04,2.04s.91,2.04,2.04,2.04h2.04v6.93c-2.07,.13-3.94,.38-5.33,.72-1.95,.48-2.86,1.09-2.86,1.94s.95,1.28,1.27,1.41c.6,.26,1.44,.5,2.49,.69,2.1,.39,4.88,.61,7.82,.61s5.72-.22,7.82-.61c1.05-.2,1.89-.43,2.49-.69,.31-.14,1.27-.56,1.27-1.41s-.91-1.46-2.86-1.94h0ZM6.57,9.92c-.37,0-.68-.3-.68-.68s.3-.68,.68-.68h10.86c.37,0,.68,.3,.68,.68s-.3,.68-.68,.68h-2.71c-.37,0-.68,.3-.68,.68v9.5c0,.37-.3,.68-.68,.68s-.68-.3-.68-.68v-5.43c0-.37-.3-.68-.68-.68s-.68,.3-.68,.68v5.43c0,.37-.3,.68-.68,.68s-.68-.3-.68-.68V10.6c0-.37-.3-.68-.68-.68h-2.71Zm12.52,11.8c-1.96,.32-4.48,.5-7.1,.5s-5.14-.18-7.1-.5c-1.95-.32-2.72-.68-3.01-.86,.23-.15,.8-.43,2.11-.71,1.26-.27,2.84-.47,4.6-.58v.53c0,1.12,.91,2.04,2.04,2.04,.52,0,1-.2,1.36-.52,.36,.32,.84,.52,1.36,.52,1.12,0,2.04-.91,2.04-2.04v-.53c1.76,.11,3.34,.31,4.6,.58,1.31,.28,1.87,.56,2.11,.71-.28,.18-1.05,.54-3.01,.86h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.75,13.31v1.36c0,.37,.3,.68,.68,.68s.68-.3,.68-.68v-1.36c0-.37-.3-.68-.68-.68s-.68,.3-.68,.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.46,11.95v4.07c0,.37,.3,.68,.68,.68s.68-.3,.68-.68v-4.07c0-.37-.3-.68-.68-.68s-.68,.3-.68,.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.25,14.67v-1.36c0-.37-.3-.68-.68-.68s-.68,.3-.68,.68v1.36c0,.37,.3,.68,.68,.68s.68-.3,.68-.68Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.86,16.7c.37,0,.68-.3,.68-.68v-4.07c0-.37-.3-.68-.68-.68s-.68,.3-.68,.68v4.07c0,.37,.3,.68,.68,.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolisticdigital);
export default __webpack_public_path__ + "static/media/holistic digital.5ddd8741a11ffc90abd3db9b0869e1d0.svg";
export { ForwardRef as ReactComponent };